import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen, MessageCircle, Calendar, TrendingUp, BarChart3 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QuickStatsProps {
  stats: {
    journals_count: number;
    chats_count: number;
    days_in_therapy: number;
    completion_rate: number;
  };
}

export function QuickStats({ stats }: QuickStatsProps) {
  const statItems = [
    {
      label: 'Diari completati',
      value: stats.journals_count,
      icon: BookOpen,
      color: 'text-green-600',
      bgColor: 'bg-green-100 dark:bg-green-900/20',
    },
    {
      label: 'Conversazioni',
      value: stats.chats_count,
      icon: MessageCircle,
      color: 'text-purple-600',
      bgColor: 'bg-purple-100 dark:bg-purple-900/20',
    },
    {
      label: 'Giorni nel percorso',
      value: stats.days_in_therapy,
      icon: Calendar,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100 dark:bg-blue-900/20',
    },
    {
      label: 'Tasso completamento',
      value: stats.completion_rate,
      suffix: '%',
      icon: TrendingUp,
      color: 'text-orange-600',
      bgColor: 'bg-orange-100 dark:bg-orange-900/20',
    },
  ];

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <div className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800">
            <BarChart3 className="h-5 w-5 text-gray-600 dark:text-gray-400" />
          </div>
          I tuoi numeri
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {statItems.map((stat, index) => {
            const StatIcon = stat.icon;
            return (
              <div
                key={index}
                className="space-y-2"
              >
                <div className="flex items-center gap-2">
                  <div className={cn('p-1.5 rounded-md', stat.bgColor)}>
                    <StatIcon className={cn('h-4 w-4', stat.color)} />
                  </div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900 dark:text-white">
                    {stat.value}
                    {stat.suffix && (
                      <span className="text-lg text-gray-600 dark:text-gray-400">
                        {stat.suffix}
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-gray-600 dark:text-gray-400 leading-tight">
                    {stat.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}